"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jsonpRequest = jsonpRequest;
function jsonpRequest(url) {
  return new Promise((resolve, reject) => {
    if (!document.head) {
      reject();
      return;
    }
    const hash = `_jsonpCallback_${getRandomCallBackId()}`;
    const script = document.createElement('script');
    script.async = true;
    script.src = url.indexOf('?') >= 0 ? `${url}&callback=${hash}` : `${url}?callback=${hash}`;
    script.onerror = e => {
      reject(e);
    };
    window.addEventListener('error', handleWindowError);

    // Handle html responses, for example 302 redirect
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function handleWindowError(_event) {
      window.removeEventListener('error', handleWindowError);
      reject();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window[hash] = data => {
      document.head.removeChild(script);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      delete window[hash];
      window.removeEventListener('error', handleWindowError);
      resolve(data);
    };
    document.head.appendChild(script);
  });
}
function getRandomCallBackId() {
  return Math.random().toString(36).substr(2, 8);
}